<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <keep-alive>
      <KVDR v-if="selectedVisibilityOption === 'Plan'" :import-data="employeesData" />
    </keep-alive>

    <vs-popup class="profile-card" v-if="userRelationshipData && userRelationshipData.by && profileCard"
      :title="userRelationshipData.from.userData.firstName + `'s ` + $t('orgDashboard.talentPool.profileCard')" :active.sync="profileCard"
      :button-close-hidden="true">
      <profile-card-popup :selectedUserData="userRelationshipData.from" />
    </vs-popup>
  </div>
</template>

<script>
// import DataViewSidebar from '../DataViewSidebar.vue'
import constants from "@/constants";
import vSelect from "vue-select";
import ProfileCardPopup from "./components/ProfileCardPopup.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Options from "../../pages/emotionhack/landing/components/Options.vue";
import KVDR from "./components/KVDR.vue";
export default {
  components: {
    // DataViewSidebar
    vSelect,
    ProfileCardPopup,
    // HeirarchyView,
    VuePerfectScrollbar,
    KVDR,
    Options,
  },
  data() {
    return {
      constants,
      selected: [],
      itemsPerPage: 50,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      deactivationInProgress: {},

      //
      reviewUserRequest: [],
      isRequestLoading: false,
      searchedUserArray: [],
      searchValue: "",
      orgColor: "",
      addRelationPrompt: false,
      removeRelationPrompt: false,
      userRelationshipData: {},
      orgEmployees: [],
      relationShipData: {},
      orgRelationShip: [],
      relationForUser: {},
      profileCard: false,
      communityVisiblityOptions: [
        {
          id: "Plan",
          activeIcon: "activeicon-kvdr",
          inactiveIcon: "inactiveicon-kvdr",
          titleKey: "orgDashboard.talentPool.viewOptions.plan"
        },
      ],
      selectedVisibilityOption: "Plan", 
      listVisible: false,
      filteredUsers: [],
      selectedUser: "",
      searchedOrgUserArray: [],
      search: "",
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    employeesData() {
      return this.$store.state.organization.employees;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    userData() {
      return this.$store.state.users.data;
    },
  },
  directives: {
    "click-outside": {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression]();
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
  watch: {
    orgData() {
      if (this.orgData && this.orgData._id) {
        this.$store.dispatch("organization/fetchAllEmployees", {
          organizationId: this.orgData._id,
        });
        this.orgColor = this.orgData.primaryThemeColor;
        this.getOrgRelation(this.orgData._id);
      }
    },
    searchValue(newVal) {
      if (newVal === "") {
        this.searchedUserArray = this.reviewUserRequest;
      }
    },
    addRelationPrompt(newVal) {
      if (newVal) {
        this.relationShipData = {};
        this.fetchOrgEmployees(this.orgData._id);
        this.getOrgRelation(this.orgData._id);
      }
    },
  },
  methods: {
    generateCustomLabel(item) {
      console.log(item);
      return "userData.firstName";
    },
    getFlag(countryCode) {
      if (countryCode)
        return `https://countryflagsapi.com/png/${countryCode.toLowerCase()}`;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getOrderStatusColor(status) {
      if (status === "on_hold") return "warning";
      if (status === "delivered") return "success";
      if (status === "canceled") return "danger";
      return "primary";
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    fetchUserById(userId) {
      if (userId) {
        const userRecord = this.$store.dispatch("users/fetchUser", userId);
        return userRecord;
      }

      return {};
    },
    fetchOrgEmployees(orgId) {
      if (this.orgEmployees.length === 0) {
        this.$store
          .dispatch("organization/getAllOrgEmployees", orgId)
          .then((res) => {
            if (res && res.data && res.data.length > 0) {
              const updatedObj = res.data.map((item) => ({
                ...item,
                fullName: `${item.userData.firstName} ${item && item.userData && item.userData.lastName
                  ? item.userData.lastName
                  : ""
                  }`,
              }));

              this.orgEmployees = updatedObj;
              this.searchedOrgUserArray = this.orgEmployees;
            }
          })
          .catch(() => { });
      }
    },
    searchUser() {
      if (this.searchValue) {
        this.searchedUserArray = this.reviewUserRequest.filter((user) => {
          if (user.data.firstName && user.data.lastName) {
            return (
              user.data.firstName
                .toLowerCase()
                .includes(this.searchValue.toLowerCase()) ||
              user.data.lastName
                .toLowerCase()
                .includes(this.searchValue.toLowerCase())
            );
          } else if (user.data.firstName) {
            return user.data.firstName
              .toLowerCase()
              .includes(this.searchValue.toLowerCase());
          } else if (user.data.lastName) {
            return user.data.lastName
              .toLowerCase()
              .includes(this.searchValue.toLowerCase());
          }
        });
        return;
      } else {
        return (this.searchedUserArray = this.orgBoardUsersArray);
      }
    },
    searchOrgUser() {
      if (this.selectedUser) {
        this.searchedOrgUserArray = this.orgEmployees.filter((user) => {
          if (user.userData.firstName && user.userData.lastName) {
            return (
              user.userData.firstName
                .toLowerCase()
                .includes(this.selectedUser.toLowerCase()) ||
              user.userData.lastName
                .toLowerCase()
                .includes(this.selectedUser.toLowerCase())
            );
          } else if (user.userData.firstName) {
            return user.userData.firstName
              .toLowerCase()
              .includes(this.selectedUser.toLowerCase());
          } else if (user.userData.lastName) {
            return user.userData.lastName
              .toLowerCase()
              .includes(this.selectedUser.toLowerCase());
          }
        });
        return;
      } else {
        return (this.searchedOrgUserArray = this.orgEmployees);
      }
    },
    getOrgRelation(orgId) {
      this.$store
        .dispatch("organization/fetchOrganizationConfig", {
          organizationId: orgId,
        })
        .then((res) => {
          if (res && res.relationship) {
            this.orgRelationShip = res.relationship.values;
          }
        })
        .catch(() => {
          this.orgRelationShip = [];
        });
    },
    selectUser(user) {
      this.selectedUser =
        user.userData.firstName + " " + user.userData.lastName;
      this.relationShipData.selectedUser = user;
      this.listVisible = false;
    },
    saveRelation() {
      const payload = {
        userIdFrom: this.relationForUser.userId,
        userIdTo: this.relationShipData.selectedUser.userId,
        assignedByUserId: this.userData._id,
        relationship: this.relationShipData.relation,
        organizationId: this.orgData._id,
      };
      this.$store
        .dispatch("organization/saveEmployeeRelation", payload)
        .then((res) => {
          if (res.message === this.$t('orgDashboard.talentPool.relationshipSavedSuccessfully')) {
            this.relationForUser.employeeRelationshipsData.push({ ...payload, userData: this.relationShipData.selectedUser.userData });
            this.$vs.notify({
              color: "success",
              text: this.$t('orgDashboard.talentPool.relationshipAddedSuccessfully'),
            });

            this.$forceUpdate();
          }
        })
        .catch(() => {
          // console.log(err);
        })
        .finally(() => {
          this.addRelationPrompt = false;
        });
    },
    openRemoveRelation(user, tr) {
      this.userRelationshipData.from = user;
      this.userRelationshipData.by = tr;
      this.removeRelationPrompt = true;
    },
    removeRelationship() {
      const payload = {
        userIdFrom: this.userRelationshipData.from.userIdFrom,
        userIdTo: this.userRelationshipData.from.userIdTo,
        relationship: this.userRelationshipData.from.relationship,
        organizationId: this.orgData._id,
      };

      this.$store
        .dispatch("organization/removeEmployeeRelationship", payload)
        .then((res) => {
          if (res.status === "SUCCESS") {
            for (let i = 0; i < this.employeesData.length; i++) {
              if (
                this.employeesData[i].userId ===
                this.userRelationshipData.by.userId
              ) {
                for (
                  let j = 0;
                  j < this.employeesData[i].employeeRelationshipsData.length;
                  j++
                ) {
                  if (
                    this.employeesData[i].employeeRelationshipsData[j]._id ===
                    this.userRelationshipData.from._id
                  ) {
                    this.employeesData[i].employeeRelationshipsData.splice(
                      j,
                      1
                    );
                  }
                }
              }
            }
            this.removeRelationPrompt = false;
            this.userRelationshipData = {};
            this.$vs.notify({
              color: "success",
              text: this.$t('orgDashboard.talentPool.relationshipRemovedSuccessfully'),
            });
            this.$forceUpdate();
          }
        })
        .catch(() => { });
    },
    toggleListVisibility(value) {
      this.listVisible = value;
      if (value === false) {
        this.selectedUser = "";
      }
    },
    getRelationName(relationObj) {
      if (relationObj && relationObj.key) {
        let orgRelations =
          this.$store.state.organization.organizationConfiguration.relationship
            .values;
        let relationLabel = orgRelations.find(
          (relation) => relation.key === relationObj.key
        ).label;
        return relationLabel;
      }
    },
  },
  mounted() {
    this.isMounted = true;
    if (this.orgData && this.orgData._id) {
      this.$store.dispatch("organization/fetchAllEmployees", {
        organizationId: this.orgData._id,
      });
      this.getOrgRelation(this.orgData._id);
    }
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }

  .hide-thead {
    .vs-table--thead {
      display: none;
    }
  }
}

.integrations-image {
  margin-left: 5px;
  margin-right: 5px;
  height: 20px;
  width: 20px;
}

.relation-btn {
  border-radius: 2em;
  border: 1px solid rgba(0, 0, 0, 0.1);
  width: fit-content;

  &-active {
    background: rgba(var(--vs-primary, "#F2C244"), 1);
    border-width: 0;
  }
}

.users-container {
  background: #fff;
  box-shadow: 0px 4px 36px rgba(24, 144, 251, 0.1);
  border-radius: 0.5rem;
  flex-wrap: wrap;

  h4 {
    color: #101828 !important;
    font-weight: 600;
  }

  .arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    // background-color: #fff;
    // border: 1px solid #98a2b3;
    color: #98a2b3;
    font-size: 22px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .next {
    right: 1em;
  }
}

.dropdown {
  position: relative;
  display: inline-block;

  &__icons {
    padding: 0.75rem 0.75rem 0 0;
    position: absolute;
    right: 0;
    top: 0;

    img {
      width: 1.75rem;
      height: 1.75rem;
      background: #fff;
    }
  }

  &__content {
    width: 100%;
    height: auto;
    max-height: 200px;
    position: absolute;
    top: 100%;
    left: 0;
    overflow: hidden;
    z-index: 100;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);

    ul {
      list-style-type: none;

      .option__selected {
        background: #989898;
        color: #fff;
      }

      li {
        padding: 0.3rem 0.75rem;
        cursor: pointer;

        .user-name {
          font-weight: 600;
        }

        &:hover {
          background: #989898;
          color: #fff;
        }
      }
    }
  }
}
</style>

<style scoped>
.input-border-circular {
  border-radius: 25px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: url("../../../assets/images/icons/search.svg") no-repeat scroll 7px 7px;
  background-size: 20px;
  background-position-y: 50%;
  background-position-x: 5%;
  padding-left: 50px;
  padding: 20px;
  width: 250px;
  height: 12px;
}

.vs-dropdown--item>>>.vs-dropdown--item-link {
  display: flex;
  align-items: center;
  margin: 0.5em 0;
  padding-left: 1em;
  padding-right: 2em;
}

.con-vs-dropdown--menu {
  max-height: 20em;
  width: max-content;

  height: auto !important;
  overflow-y: scroll;
}

.con-vs-dropdown--menu::-webkit-scrollbar {
  width: 8px;
}

/* Track */
.con-vs-dropdown--menu::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(128, 128, 128, 0.378);
  /* border-radius: 10px; */
}

/* Handle */
.con-vs-dropdown--menu::-webkit-scrollbar-thumb {
  background: rgba(199, 195, 195, 0.658);
  border-radius: 10px;
}

.vs-input>>>.vs-input--icon {
  font-size: 1.5rem;
  color: #97a4bf !important;
}

.border-user {
  border: 2px solid #d0d5dd;
}

.vs-input>>>.vs-input--input {
  box-shadow: none;
}

.vs-input>>>.vs-input--placeholder {
  top: 5px;
}

.con-vs-avatar>>>.vs-avatar--text {
  font-size: 1.5rem;
}

.vx-card>>>.vx-card__body {
  padding: 0 !important;
}

.vs-con-table {
  background: rgb(255, 255, 255);
}

.vs-con-table>>>.vs-con-tbody {
  background: #fff;
  border: 2px solid #fff;
}

.vs-table--td>>>span {
  display: flex;
  align-items: center;
}

.vs-con-table>>>.vs-table--header {
  justify-content: space-between;
}

.vs-con-table>>>.vs-table--search {
  margin-left: 1rem;
}

.con-vs-dialog>>>.vs-dialog-text {
  padding-top: 0;
}

.profile-card .name {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 34px;
  line-height: 41px;
  letter-spacing: -0.02em;
  /* Licorice */
  color: #30384b;
}

.profile-card .role-title {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 29px;
  /* Light Slate Grey */
  color: #798ba0;
}

.profile-card .current-location,
.profile-card .email {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  /* Echo Blue */
  color: #b2bac8;
}

.profile-card .heading {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 13px;
  /* identical to box height, or 93% */
  letter-spacing: 0.03em;
  text-transform: uppercase;
  /* Echo Blue */
  color: #b2bac8;
}

.profile-card .content {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  /* or 144% */
  /* Light Slate Grey */
  color: #798ba0;
}

.profile-card>>>.vs-popup--header {
  display: none !important;
}

.profile-card>>>.vs-popup {
  width: 950px;
}

.con-vs-popup>>>.vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
  overflow-x: hidden !important;
  width: auto !important;
  border-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
</style>
